import { useSelector, useDispatch } from 'react-redux';
import { PROCESOS_ELECTORALES } from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { Form, Row, Col, Select, DatePicker, message } from 'antd';
import { Button } from 'components';
import * as MensGrales from 'constants/MensajesGenerales';
import { DATE_FORMAT_DATE_PICKER, FORMAT_BACKEND } from 'constants/dateFormat';
import PropTypes from 'prop-types';
import { useForm } from 'antd/es/form/Form';
import { getCatFechas, clearFechas } from 'actions/catFechas.actions';
import './BuscadorCatalogo.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const BuscadorMonitoreo = ({ onSearch }) => {
  const dispatch = useDispatch();
  const [messageApi] = message.useMessage();
  const [searchForm] = useForm();
  const procesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));

  const validateProcesoElectoral = (_, value) => {
    const { getFieldValue } = searchForm;
    const inicioFieldValue = getFieldValue('fechaInicio');
    if (value == null && inicioFieldValue == null) {
      // return Promise.reject(Error(''));
    }
    return Promise.resolve();
  };

  const validateInitialDate = (_, dateValue) => {
    const { getFieldValue } = searchForm;
    const procesoFieldValue = getFieldValue('idProcesoGral');
    const finFieldValue = getFieldValue('fechaFin');
    if (dateValue == null && procesoFieldValue == null) {
      // return Promise.reject(Error(''));
    }
    if (finFieldValue && dateValue == null) {
      return Promise.reject(Error(fieldMsgs.ERR_DATE_FIELD_REQUIRED));
    }
    return Promise.resolve();
  };

  const validateEndDate = (_, dateValue) => {
    const { getFieldValue } = searchForm;
    const procesoFieldValue = getFieldValue('idProcesoGral');
    const inicioFieldValue = getFieldValue('fechaInicio');
    if (procesoFieldValue == null && dateValue == null) {
      // return Promise.reject(Error(''));
    }

    if (inicioFieldValue && dateValue == null) {
      return Promise.reject(Error(fieldMsgs.ERR_DATE_FIELD_REQUIRED));
    }

    if (dateValue !== null) {
      if (inicioFieldValue && dateValue.isBefore(inicioFieldValue)) {
        return Promise.reject(Error('La fecha no puede ser anterior a la fecha inicial'));
      }
    }
    return Promise.resolve();
  };

  const handleSearchByFilters = async () => {
    try {
      const { getFieldValue } = searchForm;
      const procesoFieldValue = getFieldValue('idProcesoGral');
      const inicioFieldValue = getFieldValue('fechaInicio');
      const finFieldValue = getFieldValue('fechaFin');

      if (procesoFieldValue == null && inicioFieldValue == null && finFieldValue == null) {
        return;
      }

      const params = await searchForm.validateFields();
      let inicioFormat;
      let finFormat;

      // Formatear fechas si están definidas
      if (params.fechaInicio) {
        inicioFormat = params.fechaInicio.format(FORMAT_BACKEND);
      }

      if (params.fechaFin) {
        finFormat = params.fechaFin.format(FORMAT_BACKEND);
      }

      // Realizar la búsqueda con los parámetros
      const { success, response } = await dispatch(
        getCatFechas({
          idProcesoElectoral: params.idProcesoGral,
          fechaInicio: inicioFormat,
          fechaFin: finFormat
        })
      );
      if (success && response?.data.code === 200) {
        onSearch(params);
      } else if (response?.causa !== undefined) {
        messageApi.error(response.causa);
      } else {
        messageApi.error(MensGrales.MAV1_2);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleClearFilters = () => {
    searchForm.resetFields();
    onSearch({});
    dispatch(clearFechas({}));
  };

  return (
    <div className="buscador-monitoreo">
      <Form form={searchForm} layout="horizontal">
        <Row gutter={24}>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Proceso Electoral:</span>
            <Form.Item
              name="idProcesoGral"
              rules={[
                {
                  validator: validateProcesoElectoral
                }
              ]}>
              <Select
                placeholder="Selecciona"
                allowClear
                options={procesosElectorales}
                fieldNames={{
                  value: 'idProcesoElectoral',
                  label: 'descripcion'
                }}
                filterOption={(inputValue, option) =>
                  option.descripcion?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-monitoreo-etiqueta"> </span>
            <Form.Item
              name="fechaInicio"
              label="Del"
              className="buscador-monitoreo-etiqueta"
              rules={[
                {
                  validator: validateInitialDate
                }
              ]}>
              <DatePicker placeholder="Selecciona" allowClear format={DATE_FORMAT_DATE_PICKER} />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-monitoreo-etiqueta" />
            <Form.Item
              name="fechaFin"
              label="al"
              className="buscador-monitoreo-etiqueta"
              rules={[
                {
                  validator: validateEndDate
                }
              ]}>
              <DatePicker placeholder="Selecciona" allowClear format={DATE_FORMAT_DATE_PICKER} />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-monitoreo-etiqueta" />
            <div className="buscador-monitoreo-acciones">
              <Button text="Limpiar" onClick={handleClearFilters} />
              <span style={{ width: '2em' }} />
              <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default BuscadorMonitoreo;

BuscadorMonitoreo.propTypes = {
  onSearch: PropTypes.func.isRequired
};
